// TODO: Not on API yet; use graphql generated enum once that happens
export enum DiscountType {
  percentage = 'percentage',
  fixed = 'fixed',
}
